// extracted by mini-css-extract-plugin
export default {"AgentList":"AgentList_AgentList__Tk892","name":"AgentList_name__cQj0b","type":"AgentList_type__ZIDqq","phone":"AgentList_phone__UAJ-i"};